import script from "./textLive.vue?vue&type=script&setup=true&name=TextLive&lang=js"
export * from "./textLive.vue?vue&type=script&setup=true&name=TextLive&lang=js"

import "./textLive.vue?vue&type=style&index=0&id=2ac76d9c&scoped=true&lang=css"

import exportComponent from "/Users/nasinet/hujing_pro/hj_pro_h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ac76d9c"]])

export default __exports__